import picaFactory from 'pica';

export const MAINTENANCE_PHOTO_LIMIT = 20;
export const MAINTENANCE_PHOTO_MAX_DIMENSION = 2048;
export const MAINTENANCE_PHOTO_QUALITY = 0.88;

const imageFromObjectUrl = file => new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const image = new Image();
    image.onload = () => {
        URL.revokeObjectURL(url);
        resolve(image);
    };
    image.onerror = error => {
        URL.revokeObjectURL(url);
        reject(error);
    };
    image.src = url;
});

const decodeImage = async file => {
    if (typeof createImageBitmap === 'function') {
        try {
            return await createImageBitmap(file, { imageOrientation: 'from-image' });
        } catch {
            return createImageBitmap(file);
        }
    }

    return imageFromObjectUrl(file);
};

export const maintenancePhotoDimensions = (width, height, maxDimension = MAINTENANCE_PHOTO_MAX_DIMENSION) => {
    if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) {
        throw new Error('Invalid image dimensions');
    }
    const scale = Math.min(1, maxDimension / Math.max(width, height));
    return {
        width: Math.max(1, Math.round(width * scale)),
        height: Math.max(1, Math.round(height * scale)),
    };
};

export async function compressMaintenancePhoto(file, options = {}) {
    if (!file?.type?.startsWith('image/')) {
        throw new Error('Il file selezionato non è un’immagine.');
    }

    const maxDimension = options.maxDimension ?? MAINTENANCE_PHOTO_MAX_DIMENSION;
    const quality = options.quality ?? MAINTENANCE_PHOTO_QUALITY;
    const pica = options.pica ?? picaFactory({
        features: ['js', 'wasm', 'ww'],
        idle: 2000,
    });
    const source = options.source ?? await decodeImage(file);
    const sourceWidth = source.naturalWidth ?? source.width;
    const sourceHeight = source.naturalHeight ?? source.height;
    const dimensions = maintenancePhotoDimensions(sourceWidth, sourceHeight, maxDimension);
    const canvas = options.canvas ?? document.createElement('canvas');
    canvas.width = dimensions.width;
    canvas.height = dimensions.height;

    await pica.resize(source, canvas, { alpha: false });
    const blob = await pica.toBlob(canvas, 'image/jpeg', quality);

    if (typeof source.close === 'function') {
        source.close();
    }

    return {
        blob,
        originalName: file.name || `foto-${Date.now()}.jpg`,
        mimeType: 'image/jpeg',
        width: dimensions.width,
        height: dimensions.height,
        originalSize: file.size ?? null,
        size: blob.size,
        capturedAt: new Date(file.lastModified || Date.now()).toISOString(),
    };
}